var map = {
	"./AGATA.jpg": 81,
	"./AGUAMARINA.jpg": 82,
	"./AMATISTA.jpg": 83,
	"./AMAZONITA.jpg": 84,
	"./ANGELITA.jpg": 85,
	"./AZURITA.jpg": 86,
	"./BRONCITA.jpg": 87,
	"./CALCITA.jpg": 88,
	"./CIANITA.jpg": 89,
	"./CITRINO.jpg": 90,
	"./CORNALINA.jpg": 91,
	"./CUARZO AHUMADO.jpg": 92,
	"./CUARZO AZUL.jpg": 93,
	"./CUARZO CRISTAL.jpg": 94,
	"./CUARZO LEMURIANO.jpg": 95,
	"./CUARZO ROSA.jpg": 96,
	"./CUARZO VERDE.jpg": 97,
	"./Cuarzo.jpg": 98,
	"./ESTRELLA.jpg": 99,
	"./HEMATITA.jpg": 100,
	"./JASPE (GENERAL).jpg": 101,
	"./JASPE CEBRA.jpg": 102,
	"./JASPE MOOKAITA.jpg": 103,
	"./JASPE NORINA.jpg": 104,
	"./JASPE OJO DE HIERRO.jpg": 105,
	"./JASPE PAISAJE (CUADRO).jpg": 106,
	"./JASPE PIEL DE COBRA.jpg": 107,
	"./JASPE ROJO.jpg": 108,
	"./JASPE SANGUINA.jpg": 109,
	"./LAPIZ LAZULI.jpg": 110,
	"./LODONITA.jpg": 111,
	"./OBSIDIANA.jpg": 112,
	"./OJO DE BUEY.jpg": 113,
	"./OJO DE TIGRE.jpg": 114,
	"./ONIX NEGRO.jpg": 115,
	"./PIEDRA LUNA.jpg": 116,
	"./PIRITA.jpg": 117,
	"./RODOCROCITA.jpg": 118,
	"./Rodocrosita.jpg": 119,
	"./SELENITA NARANJA.jpg": 120,
	"./SELENITA.jpg": 121,
	"./SHUNGITA.jpg": 122,
	"./SODALITA.jpg": 123,
	"./TURMALINA NEGRA.jpg": 124,
	"./TURMALINA ROSA.jpg": 125,
	"./TURMALINA VERDE.jpg": 126,
	"./TURMALINA VERDER.jpg": 127,
	"./TURMALINA.jpg": 128,
	"./cristalHeader.jpg": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;